window.addEventListener("DOMContentLoaded", function () {
  const max_interval = 10;
  let interval_count = 0;
  const interval = setInterval(function () {
    const title = document.querySelector(".jdgm-rev-widg__title");
    const el = document.querySelector(".jdgm-link");

    if (el) {
      let text = el.textContent.trim();

      let rating = parseFloat(text.match(/[\d.]+/)[0]);
      if (title)
        title.innerHTML = `${rating} Stars From Thousands of Happy Customers`;
    }

    interval_count++;
    if (interval_count >= max_interval) {
      clearInterval(interval);
    }
  }, 1000);
});
